import {Component, Input} from '@angular/core';
import { InfraChargeDto } from '../../../domain/infra/infraChargeDto';
import { PowerInWToKwPipe } from '../../../pipes/powerInWToKw.pipe';
import {GhostComponent} from '../../../utils/ghostComponent';
import { FrontIziviaTranslateService } from '../../../services/i18n/iziviaTranslate.service';

@Component({
    selector: 'infra-charge',
    templateUrl: './infraCharge.component.html',
    styleUrls: ['./infraCharge.component.scss'],
})
export class InfraChargeComponent extends GhostComponent {
    @Input() infraCharge: InfraChargeDto;

    constructor(private readonly translateService: FrontIziviaTranslateService,
        private readonly powerInWToKwPipe: PowerInWToKwPipe) {
        super();
    }

    formatChargePointInfos() {
        if (!this.infraCharge) {
            return;
        }

        const message: Array<string> = [];

        const isStationName = this.infraCharge.station && this.infraCharge.station.name;
        if (isStationName && this.infraCharge.chargePoint && this.infraCharge.chargePoint.name) {
            message.push(
                this.translateService.translate('infra.stationAndChargePoint', {
                    stationVisualId: this.infraCharge.station.name,
                    chargePointVisualId: this.infraCharge.chargePoint.name
                })
            );
        } else if (isStationName) {
            message.push(
                this.translateService.translate('infra.station', {
                    stationVisualId: this.infraCharge.station.name,
                })
            );
        }

        if (this.infraCharge.plug && this.infraCharge.plug.maxPowerInW) {
            message.push(this.powerInWToKwPipe.transform(this.infraCharge.plug.maxPowerInW));
        }

        return message.join(' - ');
    }

    public generateGhost(): void {
    }
}
